import React from "react";
import { Image } from "react-bootstrap";
import { useSelector } from "react-redux";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageNavigationButtons from "../navBar/pageNavigationButtons";
import ContentSection from "./contentSection";

//IMAGES
import MainPhoto from "./images/Main Photo.png";

function Home() {
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);

    return (
        <div
            style={{
                border: "1px solid black",
                height: "100vh",
                width: "100vw",
                backgroundImage: `url('/content/mainStyle/homeSections/backgroundImages/image1.jpg')`,
                backgroundSize: "cover"
            }}
        >
            <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_blueBackground : SectionsStyles.blueBackground}>
                <PageNavigationButtons />
                <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_insideContainer : SectionsStyles.insideContainer}>
                    <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_whiteCentredSection : SectionsStyles.whileCentredSection}>
                        <div style={SectionsStyles.contentContianer}>
                            <ContentSection pageID={0} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Home;
